import { FC } from "react";
import { IconProps } from "@/shared/types/icon";
import { Svg } from "@abel-technologies-as/components";

export const PersonIcon: FC<IconProps> = ({ width = "22.2", height = "20.8", color = "none", onClick, className }) => {
	return (
		<Svg className={className} width={width} height={height} onClick={onClick} viewBox="0 0 18 20" fill={color}>
			<path
				d="M6.00805 1.00391L6.72068 6.01262C6.82602 7.11598 7.05159 7.85569 6.45684 9.04675L3.99634 14M7.12891 6.64062L10.5547 8.0625L13.2723 9.2047C13.2945 9.21401 13.3162 9.22498 13.3366 9.23756C13.9881 9.63795 14.2303 10.0536 14.4648 10.9766L17 19M6.72656 10.0352L11.1758 11.8242M13.3797 10.2114L11.6703 11.949L9.00781 18.9961M4 7.5C4 8.3284 3.32843 9 2.5 9C1.67157 9 1 8.3284 1 7.5C1 6.67157 1.67157 6 2.5 6C3.32843 6 4 6.67157 4 7.5Z"
				stroke="#344054"
				strokeWidth="2"
			/>
		</Svg>
	);
};
